import { Input } from '~/components/ui'

export default function MapSearchFilter({
  search,
  updateFilter,
}: {
  search?: string
  updateFilter: (updates: Record<string, any>) => void
}) {
  return (
    <div className="space-y-2">
      <p className="text-sm">Keyword Search (1 - 3 terms)</p>

      <Input
        value={search || ''}
        onChange={(e) => {
          updateFilter({ search: e.target.value })
        }}
      />
    </div>
  )
}
